
import mainRouter from '@/router/mainRouter'
import patientRouter from '@/router/patientRouter'
import planRouter from '@/router/planRouter'
import doctorRouter from '@/router/doctorRouter'
import billRouter from '@/router/billRouter'
import shipRouter from '@/router/shipRouter'
import boardRouter from '@/router/boardRouter'
import orderRouter from '@/router/orderRouter'
const mainLayoutRouter = [
    {
        path: '',
        redirect: '/board'
    }, {
        path: 'main',
        name: 'main',
        children: mainRouter
    }, {
        path: 'order',
        name: 'order',
        children: orderRouter
    }, {
        path: 'patient',
        name: 'patient',
        children: patientRouter
    }, {
        path: 'plan',
        name: 'plan',
        children: planRouter
    }, {
        path: 'doctor',
        name: 'doctor',
        children: doctorRouter
    }, {
        path: 'bill',
        name: 'bill',
        children: billRouter
    }, {
        path: 'ship',
        name: 'ship',
        children: shipRouter
    }, {
        path: 'board',
        name: 'board',
        children: boardRouter
    }, {
        path: 'pdf',
        name: 'pdf',
        component: () => import(/* webpackChunkName: "about" */ '../views/pdf.vue')
    }
]
export default mainLayoutRouter